<template>
  <div>
    <!-- <v-container> -->
    <v-row>
      <v-col cols="0" sm="2" md="1">
        <v-card v-if="$vuetify.breakpoint.smAndUp" class="extend">
          <v-navigation-drawer permanent expand-on-hover>
            <v-list>
              <v-list-item
                ><v-list-item-icon>
                  <v-icon color="secondary">mdi-file-tree</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Hierarchy</v-list-item-title>
                  <v-list-item-subtitle>Part Of</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
            <div v-if="hasParent">
              <v-divider></v-divider>
              <v-list nav>
                <v-list-item
                  v-for="i of hierarchy"
                  :key="i.id.value"
                  :to="`/individual/${encodeURIComponent(i.id.value)}`"
                  ripple
                >
                  <v-list-item-icon>
                    <v-icon color="secondary">{{ recIconType(i.type) }}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ i.label.value }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </div>
          </v-navigation-drawer>
        </v-card>
      </v-col>
      <v-col cols="12" sm="10" md="11">
        <!-- display: block -->
        <v-alert v-if="individualPending" type="error">
          Individual "{{ id }}" not read
        </v-alert>
        <individual-expanded
          v-else
          :individual="individual"
        ></individual-expanded>
      </v-col>
    </v-row>
    <!-- </v-container> -->
  </div>
</template>

<script>
import Vue from 'vue'

import IndividualExpanded from '@/components/IndividualExpanded.vue'
// TODO add guard for reading individual

import { Iri } from '@/rec-cache/rec-cache-types'
import { recIcon } from '@/vue-wob-cache/vue-wob-icons'
import { RecIndividual } from '@/rec-cache/rec-cache-individual'
import { upProperties, downProperties } from '@/rec-cache/rec-cache-hierarchies'

export default {
  components: { IndividualExpanded },
  props: {
    id: {
      type: String,
      default: () => '',
    },
  },
  data: () => ({
    individual: new RecIndividual(),
    hierarchy: [],
  }),
  computed: {
    hasParent: function () {
      return !!this.hierarchy.length
    },
    individualPending: function () {
      return !this.individual?.id.isDefined
    },
  },

  // computed: {
  //   dataProperties: function () {
  //     return this.individual.properties.filter((p) => p instanceof DataProperty)
  //   },
  //   objectProperties: function () {
  //     return this.individual.properties.filter(
  //       (p) => p instanceof ObjectProperty
  //     )
  //   },

  //   inverseObjectProperties: function () {
  //     const edges = this.$wob.queryEdges({ target: this.id })
  //     const properties = []
  //     const labels = []
  //     edges.forEach((e) => {
  //       if (!labels.includes(e.label.value)) {
  //         labels.push(e.label.value)
  //         properties.push(new ObjectProperty(e.label, []))
  //       }
  //       properties.find((p) => p.name.equals(e.label.value))?.addValue(e.source)
  //     })
  //     return properties
  //   },

  //   recTypeIcon: function () {
  //     return recIcon(this.individual.type)
  //   },
  // },
  beforeRouteUpdate: function (to, from, next) {
    console.log('components.individual-view.before-route-update', to)
    // TODO extract this code and created function below into one method.
    this.individual = this.$wob.read(new Iri(to.params.id), true)
    this.hierarchy = this.traverseUp(this.individual.id)
      .slice(1)
      .reverse()
      // TODO consider how aggregation impacts the hierarchy
      .map((id) => this.$wob.read(id))
    next()
  },

  created: function () {
    console.time(this.id)
    console.log(
      'views.individual-view.created',
      this.id,
      JSON.stringify(this.id)
    )
    this.individual = Vue.observable(this.$wob.read(new Iri(this.id), true))
    // TODO manage if individual is not returned...
    console.log('views.individual-view.created.individual', this.individual)
    this.hierarchy = this.traverseUp(this.individual.id)
      .slice(1)
      .reverse()
      // TODO consider how aggregation impacts the hierarchy
      .map((id) => this.$wob.read(id))
  },
  mounted: function () {
    console.log('views.individual-view.mounted', this.id)
    console.timeEnd(this.id)
  },
  methods: {
    // Parameter is an Iri.
    recIconType: function (type) {
      return recIcon(type)
    },
    // Recursive traversal upwards. Parameter is Iri. Returns an array of Iris.
    traverseUp: function (id) {
      const path = [id]
      console.log('components.individual-list-item.traverse-up.path', path)
      const upEdges = this.$wob
        .queryEdges({ source: id.value })
        .filter((e) => upProperties.includes(e.label.value))
      const downEdges = this.$wob
        .queryEdges({ target: id.value })
        .filter((e) => downProperties.includes(e.label.value))

      // TODO dealing with several individuals on a level...
      path.push(
        ...upEdges
          .map((e) => this.traverseUp(e.target))
          .reduce((previous, current) => previous.concat(current), [])
      )

      path.push(
        ...downEdges
          .map((e) => this.traverseUp(e.source))
          .reduce((previous, current) => previous.concat(current), [])
      )

      return path
    },
  },
}
</script>

<style>
.extend {
  width: 56px;
  transform: translateX(0);
}

.extend:hover {
  width: 256px;
  transform: translateX(0);
  position: absolute;
  z-index: 5;
}
</style>
